module.exports = __webpack_public_path__ + "img/f4f61c9f-735b-4fce-94e5-3b410f330694.f9289d10.png";